import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@/environments/environment";
import { Configuration, ConfigurationAction, Menu } from "@/app/shared/interfaces/configuration.interface";
import { Observable } from "rxjs";
import { BaseResponseModel } from "../interfaces/base-response.interface";
import { SubscribeListModel } from "../interfaces/notification.interface";

@Injectable({
  providedIn: "root",
})
export class ConfigurationService {

  constructor(private http: HttpClient) {}

  getConfiguration(userName?: string) {
    // return this.http.get<Configuration>(`${environment.baseURL}configuration`);
    if (userName)
      return this.http.get<Configuration>(`${environment.baseURL}configuration/configuration/${userName}`);
    else
      return this.http.get<Configuration>(`${environment.baseURL}configuration/configuration`);
  }

  upsertConfigurationForUser(model: string, action: ConfigurationAction) {
    return this.http.post(`${environment.baseURL}configuration/configuration?action=${action}`, model, {
      headers: {
        "Content-Type": "application/json"
      }
    });
  }

  getSideBar() {
    return this.http.get<Menu[]>(`${environment.baseURL}configuration/configuration/admin-sidebar`);
  }
  getHomeConfiguration(region: string) {
    return this.http.get(`${environment.baseURL}configuration/configuration/home-config/${region}`);
  }
  getHomeBanner(region: string) {
    return this.http.get(`${environment.baseURL}configuration/configuration/home-banner/${region}`);
  }

  getVendorBanner(region: string) {
    return this.http.get(`${environment.baseURL}configuration/configuration/vendor-banner/${region}`);
  }

  getCommentBanner(region: string) {
    return this.http.get(`${environment.baseURL}configuration/configuration/comment-banner/${region}`);
  }

  getPopupBanner(region: string) {
    return this.http.get(`${environment.baseURL}configuration/configuration/popup-banner/${region}`);
  }
  getFlashsaleInfo() {
    return this.http.get(`${environment.baseURL}configuration/configuration/flashsale-info`);
  }

  getGiftInfo() {
    return this.http.get<Menu[]>(`${environment.baseURL}configuration/configuration/gift-info`);
  }

  updateHomeConfiguration(model: any,region: string) {
    return this.http.post(`${environment.baseURL}configuration/configuration/home-config/${region}`, model, {
      headers: {
        "Content-Type": "application/json"
      }
    });
  }

  updateVendorBanner(model: any,region: string) {
    return this.http.post(`${environment.baseURL}configuration/configuration/vendor-banner/${region}`, model, {
      headers: {
        "Content-Type": "application/json"
      }
    });
  }

  updateCommentBanner(model: any,region: string) {
    return this.http.post(`${environment.baseURL}configuration/configuration/comment-banner/${region}`, model, {
      headers: {
        "Content-Type": "application/json"
      }
    });
  }

  updatePopupBanner(model: any,region: string) {
    return this.http.post(`${environment.baseURL}configuration/configuration/popup-banner/${region}`, model, {
      headers: {
        "Content-Type": "application/json"
      }
    });
  }

  updateFlashsaleInfo(model: any) {
    return this.http.post(`${environment.baseURL}configuration/configuration/flashsale-info`, model, {
      headers: {
        "Content-Type": "application/json"
      }
    });
  }

  updateGiftInfo(model: any) {
    return this.http.post(`${environment.baseURL}configuration/configuration/gift-info`, model, {
      headers: {
        "Content-Type": "application/json"
      }
    });
  }
}
